import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="discount-form"
export default class extends Controller {
  static targets = ['quantityField', 'ticketsBundleWrapper', 'selectedTicket', "csvUploadField", "fileName",
    "fileUploadWrapper", "fileNameWrapper", 'ticketLimitField']

  connect() {
    this.enableDisableQuantity()
  }

  enableDisableQuantity() {
    if (this.ticketLimitFieldTarget.value == 'unlimited') {
      this.quantityFieldTarget.disabled = true
      this.quantityFieldTarget.value = ''
    } else {
      this.quantityFieldTarget.disabled = false;
    }
  }

  hideTickets() {
    this.ticketsBundleWrapperTarget.classList.add('d-none')
  }

  showTickets() {
    this.ticketsBundleWrapperTarget.classList.remove('d-none')

    if (this.hasTicketsBundleWrapperTarget) {
      this.ticketsBundleWrapperTarget.scrollIntoView({ behavior: 'smooth' });
    }
  }

  openFilePicker() {
    this.csvUploadFieldTarget.click()
  }

  displayFileName() {
    this.fileNameTarget.innerHTML = event.currentTarget.files[0].name
    this.fileNameWrapperTarget.classList.remove('d-none')
    this.fileUploadWrapperTarget.classList.add('d-none')
  }

  removeSelectedFile() {
    this.csvUploadFieldTarget.value = ''
    this.fileNameWrapperTarget.classList.add('d-none')
    this.fileUploadWrapperTarget.classList.remove('d-none')
  }
}
